import React from 'react';
import { BookOpenIcon, GiftIcon, TrophyIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { offer } from '../data/offer';
export function OfferSection() {
  const perks = ['One-time payment', 'Lifetime access to the purchased digital materials', 'No monthly fees', 'Instant download'];
  return <section id="offer" className="w-full bg-navy-950 px-5 py-16 text-white sm:py-20" data-id="element-173" data-mp="ic6q7r536rxb">
      <div className="mx-auto max-w-2xl" data-id="element-174" data-mp="me1yxgpck7l4">
        <div className="flex justify-center" data-id="element-175" data-mp="md0fanu9mcrs">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold-400 px-4 py-1.5 font-display text-base font-bold uppercase tracking-wider text-ink" data-id="element-176" data-mp="rdeoi97lrsre">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="wan72awnxyt6" />
            Special launch offer
          </span>
        </div>
        <h2 className="mt-4 text-center font-display text-[38px] font-extrabold uppercase leading-[0.98] sm:text-5xl" data-id="element-178" data-mp="2y3ujnckw62bd">
          Here's everything you'll <span className="text-electric-400" data-id="element-179" data-mp="12p35t5e9pkop">receive today</span>
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white text-ink" data-id="element-180" data-mp="xvqsvsiyb2bs">
          <ul className="divide-y divide-slate-200" data-id="element-181" data-mp="sx78hwk09ylj">
            <li className="flex items-center gap-4 p-5" data-id="element-182" data-mp="svmce2i1m7lk">
              <BookOpenIcon className="h-7 w-7 shrink-0 text-electric-600" aria-hidden="true" data-id="element-183" data-mp="ox543fmvyr2k" />
              <span className="flex-1 text-[16px] font-bold leading-snug" data-id="element-184" data-mp="1lmmjwnfl1thz">TCM Diagnostic Blueprint™ — 6 Premium Volumes</span>
              <s className="font-display text-xl font-bold text-muted" data-id="element-185" data-mp="1gnt24it9jgc0">{offer.volumesValue}</s>
            </li>
            <li className="flex items-center gap-4 p-5" data-id="element-186" data-mp="1cjv64gz8iln6">
              <GiftIcon className="h-7 w-7 shrink-0 text-alert-600" aria-hidden="true" data-id="element-187" data-mp="17neehcsttp5c" />
              <span className="flex-1 text-[16px] font-bold leading-snug" data-id="element-188" data-mp="172fxam3e598">5 Professional Bonuses</span>
              <s className="font-display text-xl font-bold text-muted" data-id="element-189" data-mp="3scat77p2tjov">{offer.bonusesValue}</s>
            </li>
            <li className="flex items-center justify-between gap-4 bg-canvas p-5" data-id="element-190" data-mp="3tv14qhuph981">
              <span className="font-display text-xl font-extrabold uppercase" data-id="element-191" data-mp="2o83xf3trc41">Total reference value</span>
              <s className="font-display text-2xl font-extrabold text-alert-600" data-id="element-192" data-mp="3ku2ydswsopma">{offer.totalValue}</s>
            </li>
          </ul>
          <div className="bg-cta-600 px-5 py-7 text-center text-white" data-id="element-193" data-mp="3otbrcvk0gjgs">
            <p className="font-display text-xl font-bold uppercase tracking-wide" data-id="element-194" data-mp="3b2gr27nkvaot">Today you get everything for just…</p>
            <p className="mt-1 font-display text-[88px] font-black leading-none" data-id="element-195" data-mp="3fvt2th75rn05">
              {offer.price}
              <span className="ml-2 text-3xl font-extrabold" data-id="element-196" data-mp="31758tfcynlcb">USD</span>
            </p>
          </div>
          <ul className="grid gap-2.5 p-5 sm:grid-cols-2" data-id="element-197" data-mp="364omoe5qxw3q">
            {perks.map(p => <li key={p} className="flex gap-2.5 text-[15px] font-medium" data-id="element-198" data-mp="2s5fjcf2n2wh6">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-600" strokeWidth={3} aria-hidden="true" data-id="element-199" data-mp="2x2p7zsi7f43y" />
                {p}
              </li>)}
          </ul>
        </div>

        <ScarcityBar data-id="element-200" data-mp="28jvuesfwzwhp" />
        <CtaButton label="Get TCM Diagnostic Blueprint™" tone="dark" className="mt-8" data-id="element-201" data-mp="28kf11d046ygf" />
        <Countdown tone="dark" data-id="element-202" data-mp="2mjenqf42h39y" />

        <div className="mt-14 space-y-4 text-[16px] leading-relaxed text-slate-300" data-id="element-203" data-mp="2mgacwyw3j9ab">
          <h3 className="font-display text-[28px] font-extrabold uppercase leading-tight text-white" data-id="element-204" data-mp="2ifqja5aqensx">Why I created this offer</h3>
          <p data-id="element-205" data-mp="2rhq1v21e9zxz">
            I didn't want to create another expensive, time-consuming course that forces you to sit through hours of
            information before you can use anything. I wanted to create something practical.
          </p>
          <p data-id="element-206" data-mp="318koi7ijz1jy">
            Something you could open when a TCM arrives at your workshop. Something that helps you organize the
            information, follow a structured process, and document your next step.
          </p>
          <p data-id="element-207" data-mp="3aa0xqbxmsxml">That's why I brought the six volumes and five bonuses together in one affordable package.</p>
          <p className="border-l-4 border-gold-400 pl-4 text-lg font-semibold text-white" data-id="element-208" data-mp="18is3yczzku60">
            You're not paying $27 for another collection of PDFs. You're getting a structured reference system designed
            to help you approach TCM jobs more consistently.
          </p>
        </div>
        <CtaButton label="Yes! I want it for just $27" tone="dark" className="mt-10" data-id="element-209" data-mp="1m9nhi2lfjzfx" />
      </div>
    </section>;
}